export interface BaselinePrompt {
  id: string;
  text: string;
}

export const BASELINE_PROMPTS: BaselinePrompt[] = [
  {
    id: 'prompt-morning',
    text: 'Skriv om hvad du lavede i går — eller hvad du skal i dag.',
  },
  {
    id: 'prompt-message',
    text: 'Skriv en kort besked til en kollega eller ven, som du ville sende i dag.',
  },
  {
    id: 'prompt-thought',
    text: 'Skriv frit om en tanke du har haft for nylig.',
  },
];

export function pickBaselinePrompt(seed?: number): BaselinePrompt {
  const idx =
    seed !== undefined
      ? Math.abs(seed) % BASELINE_PROMPTS.length
      : Math.floor(Math.random() * BASELINE_PROMPTS.length);
  return BASELINE_PROMPTS[idx]!;
}
